<template>
  <div class="outStockBox">
    <div class="outStock_head">
        <span>出库将扣减库存</span>
        <span class="isCursor" @click="hideBox('')"><i class="el-icon-close"></i></span>
    </div>
    <div class="outStock_content">
        <el-table ref="multipleTable" :border='true' max-height='500px' :data="tableData" tooltip-effect="dark" style="width: 100%">
            <el-table-column label="商品" width="160">
                <template slot-scope="scope"><span>{{ scope.row.name }}</span></template>
            </el-table-column>
            <el-table-column  label="当前库存" width='100'>
                <template slot-scope="scope"><span>{{ scope.row.num }}</span></template>
            </el-table-column>
            <el-table-column  label="即将出库" width='100'>
                <template slot-scope="scope"><span >{{ scope.row.count }}</span></template>
            </el-table-column>
            <el-table-column  label="状态" width='80'>
                <template slot-scope="scope"><span v-if="!scope.row.bind_order_id" :style="{color:scope.row.needAdd?'#ff1d1d':'#5b9d5b'}">{{scope.row.needAdd?'不足':'充足'}}</span><span v-if="scope.row.bind_order_id">已生成采购单</span></template>
            </el-table-column>
            <el-table-column  label="需采购" width='80'>
                <template slot-scope="scope"><span >{{scope.row.needAdd}}</span></template>
            </el-table-column>
            <el-table-column  label="供应商">
                <template slot-scope="scope">
                    <!-- <select name="" id="" style="border:none;outline:none;" v-if="scope.row.needAdd" :data-goodid='scope.row.id' @change="setSupplierInfo">
                        <option value="0" disabled selected>请选择供应商</option>
                        <option :value="item.id" v-for="item in supplierList" :key="item.id">{{item.name}}</option>
                    </select> -->
                    <el-select v-model="scope.row.ex_supplier_id" v-if="scope.row.needAdd && !scope.row.bind_order_id" :data-goodid='scope.row.id' @change="setSupplierInfo" placeholder="请选择">
                        <el-option
                        v-for="item in supplierList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="outStock_foot">
        <!-- <p v-if="stockNoWorth.length&&!importedOrders.length">库存不足的商品，是否生成采购单？</p> -->
        <p v-if="stockNoWorth.length&&!importedOrders.length">有库存不足的商品，系统可自动生成采购单</p>
        <div class="outStock_sure_cancle">
            <!-- <p>已经生成采购单3个，2个已经入库</p> -->
            <!-- <div class="outStock_sure isCursor"  v-if="importedOrders.length && stockNoWorth.length" @click="hideBox('')">再等等</div> -->
            <div class="outStock_sure isCursor" @click="outStockFun">全部出库</div>
            <div class="outStock_sure isCursor"  v-if="stockNoWorth.length&&!importedOrders.length" @click="productBuyOrder">生成采购单</div>
            <!-- 需求吧 -->
            <div class="outStock_cancle isCursor" @click="dev" v-if="stockNoWorth.length">{{stockNoWorth.length ?'部分出库':'全部出库'}}</div>
        </div>
    </div>
  </div>
</template>

<script>
// import { addManualOrder,saveBill,sellerBuyerBindOrderId } from '../../../util/requests'
import { handleOutStockList,handlePartOutImportStock } from '../../../util/processingData'
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
    props:['info','address'],
    data(){
        return{
            importedOrders:[],//已经生成采购单的商品
            tableData:[],
            stockNoWorth:[],//库存不足商品
            supplierList:[]
        }
    },
    methods:{
        async productBuyOrder(){
            // 选择了供应商的行
            let infos = this.stockNoWorth.filter(item => {
                if(item.ex_supplier_id){
                    return item
                }
            })
            console.log(infos,this.stockNoWorth)
            if(infos.length != this.stockNoWorth.length){
                this.$message('请选择供应商')
                return
            }
            if(!Object.keys(this.address).length){
                this.$message('您还未设置地址，请到个人中心设置默认地址')
                return
            }
            // 处理生成采购单的数据
            
            let formData = handleOutStockList(infos,this.userInfo,this.supplier_id,this.address,this.identityMode?this.staffInfo.id:0)
            let Data = {}
            infos.forEach(item => {
                if(Data.hasOwnProperty(item.ex_supplier_id)){
                    Data[item.ex_supplier_id].push(item)
                }else{
                    Data[item.ex_supplier_id] = []
                    Data[item.ex_supplier_id].push(item)
                }
            })
            // 生成采购订单
            for(let i in formData){
                await this.$requests.addManualOrder(formData[i]).then(res => {
                    Data[i].forEach(item => {
                        item.bind_order_id = res.order_ids[0]
                    })
                })
            }
            let allBindIds = []
            for(let i in Data){
                Data[i].forEach(item => {
                    let bindIds = {
                        id:item.commodity_id,
                        bind_order_id:item.bind_order_id,
                        out_count:0
                    }
                    allBindIds.push(bindIds)
                })
            }
            this.$requests.sellerBuyerBindOrderId(allBindIds).then(res =>{
                console.log(res)
            })
            
            // this.axios.post('https://ggtools.thinkerx.com/erp/bind_order_id',{
            //     commodity_list:allBindIds
            // }).then(res => {

            // })
            this.$message({
                duration: '1000',
                message: '生成采购单成功',
                type: 'success'
            })
            this.$emit('getOrderList')
            this.hideBox('')
        },
        setSupplierInfo(supId){
            this.stockNoWorth.forEach(item => {
                if(item.ex_supplier_id == supId){
                    item.ex_supplier_name = this.supplierList.filter(e => {
                        if(e.id == supId){
                            return e
                        }
                    })[0].name
                }
            })
        },
        hideBox(value){
            this.$emit('hideOutStockBox')
        },
        getSupplierList(){
            // this.axios.post('https://ggtools.thinkerx.com/erp/supplier_management_get_vendor',{
            //     uid:this.userInfo.id
            // }).then(res => {
            //     this.supplierList = res.data.data.res
            // })
            this.$post("/py/erp/supplier_management_get_vendor",{
                uid:this.userInfo.id
            },res => {
                this.supplierList = res.data.res
            })
        },
        dev(){
            if(this.tableData.length == 0){
                this.$message({
                    message: '手动输入的商品，无法出库！',
                    duration: '2000'
                })
                return
            }
            // 全部出库,stockNoWorth未空的是时候代表没有库存不足的商品
            if(!this.stockNoWorth.length){
                // let outStockList = this.tableData.filter(item => {
                //     if(item.count -item.out_count){
                //         return item
                //     }
                // })
                let outStockList = this.tableData
                // 调出库接口
                // console.log(outStockList)
                let formData = handlePartOutImportStock(outStockList,'out',this.supplier_info,this.userInfo)
                formData.payed_money = this.info.manual_flag?this.info.balance.paid:this.info.final_cost
                formData.supplier_name = this.info.name
                formData.order_id = this.info.id
                this.$requests.saveBill(formData).then((res) => {
                    if (res) {
                        if(res){
                            this.$message('出库成功');
                            this.hideBox('')
                            this.$emit('getOrderList')
                        }
                    }
                })
                let Data = {}
                this.tableData.forEach(item => {
                    if(Data.hasOwnProperty(item.ex_supplier_id)){
                        Data[item.ex_supplier_id].push(item)
                    }else{
                        Data[item.ex_supplier_id] = []
                        Data[item.ex_supplier_id].push(item)
                    }
                })
                let allBindIds = []
                for(let i in Data){
                    Data[i].forEach(item => {
                        let bindIds = {
                            id:item.commodity_id,
                            bind_order_id:item.bind_order_id,
                            out_count:item.count
                        }
                        allBindIds.push(bindIds)
                    })
                }
                this.$requests.sellerBuyerBindOrderId(allBindIds).then(res =>{
                    
                })
                
            }
            // 部分出库
            else{
                this.$message('正在开发中')
                return
                let partStockList = this.tableData.filter(item => {
                    if((item.count -item.out_count) && !item.needAdd){
                        return item
                    }
                })
                console.log(partStockList)
            }
        },
        outStockFun(){
            let outStockList = this.tableData
            // 调出库接口
            // console.log(outStockList)
            let formData = handlePartOutImportStock(outStockList,'out',this.supplier_info,this.userInfo)
            formData.payed_money = this.info.manual_flag?this.info.balance.paid:this.info.final_cost
            formData.supplier_name = this.info.name
            formData.order_id = this.info.id
            this.$requests.saveBill(formData).then((res) => {
                if(res){
                    this.$message('出库成功');
                    this.hideBox('')
                    this.$emit('getOrderList')
                }
            })
            let Data = {}
            this.tableData.forEach(item => {
                if(Data.hasOwnProperty(item.ex_supplier_id)){
                    Data[item.ex_supplier_id].push(item)
                }else{
                    Data[item.ex_supplier_id] = []
                    Data[item.ex_supplier_id].push(item)
                }
            })
            console.log(Data)
            let allBindIds = []
            for(let i in Data){
                Data[i].forEach(item => {
                    let bindIds = {
                        id:item.commodity_id,
                        bind_order_id:item.bind_order_id,
                        out_count:item.count
                    }
                    allBindIds.push(bindIds)
                })
            }
            this.$requests.sellerBuyerBindOrderId(allBindIds).then(res =>{
                
            })
        }
    },
    mounted(){
        // console.log('出库数据',this.info)
        this.tableData = this.info.commodity_list.filter(item => {
            // 去掉手动添加的商品，没有id
            if(item.id != 0){
                return item
            }
        })
        // 已生成采购单的商品
        this.importedOrders = this.info.commodity_list.filter(item => {
            if(item.bind_order_id){
                return item
            }
        })
    },
    computed:{
        ...mapGetters({
        staffInfo: "staffInfo",
        }),
        ...mapState(["identityMode"]),
        // needPurchase(){
        //     return (row) => {
        //         let deff = row.count - row.num
        //         if(deff > 0){
        //             return deff
        //         }else{
        //             return ''
        //         }
        //     }
        // },
        supplier_info(){
            return this.$store.state.supplierInfo
        },
        userInfo(){
          return this.$store.state.userInfo
        },
        isOut(){
            return (count,outCount) => {
                if((count - outCount) >0){
                    // 未完全出库
                    return 1
                }else{
                    // 已完全出库
                    return 0
                }
            }
        },
        supplier_id(){
          if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
          }else{
            return 0
          }
        },
        userInfo(){
          return this.$store.state.userInfo
        },
    },
    watch:{
        'tableData':function(){
            this.stockNoWorth = this.tableData.filter(item => {
                if(!item.num){
                    item.num = 0
                }
                if((item.count - item.num) > 0){
                    item.needAdd = item.count - item.num
                    return item
                }
            })
            if(this.stockNoWorth.length){
                // 我的供应商列表
                this.getSupplierList()
            }
        }
    }
}
</script>

<style lang='less'>
    .el-table .cell{
        text-align: center;
    }
    .outStockBox{
        color: #333;
        width: 700px;
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #fff;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        padding: 10px 20px;
        .isCursor{
            cursor: pointer;
        }
        .outStock_head{
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            
            
        }
        .outStock_foot{
            margin-top: 20px;
            text-align: center;
            .outStock_sure_cancle{
                display: flex;
                justify-content: center;
                // align-items: center;
                margin-top: 20px;
                position: relative;
                >p{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                }
                >div{
                    padding: 6px 20px;
                    border-radius: 4px;
                    &.outStock_sure{
                        margin-right: 10px;
                        color: #fff;
                        background: linear-gradient(131deg, #87B3FF 0%, #6376F7 100%);;
                    }
                    &.outStock_cancle{
                        border: 1px solid #666;
                    }
                }
            }
        }
    }
</style>